import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=6028b084&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"
import style0 from "./heading.vue?vue&type=style&index=0&id=6028b084&prod&lang=scss"
import style1 from "./heading.vue?vue&type=style&index=1&id=6028b084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028b084",
  null
  
)

export default component.exports